// plugins/logger.client.js
import log from 'loglevel';


const originalFactory = log.methodFactory;

log.methodFactory = function (methodName, logLevel, loggerName) {
  const rawMethod = originalFactory(methodName, logLevel, loggerName);
  
  return function (...args) {
    const level = methodName.toUpperCase(); // Log level (e.g., INFO, ERROR)
    
    // Prepend the formatted message to the original log arguments
    rawMethod(JSON.stringify({
        '@timestamp': new Date(),
        message: args[0],
        level: level,
      }),[] );
  };
};

log.setLevel(log.getLevel());

export default defineNuxtPlugin({
  name:'logger-client',
  enforce: 'pre', // or 'post',
  setup(){

  return {
    provide: {
      log,
    },
  };
}});
